import axios from 'axios';
import { API_BASE_URL } from '../utills/constant';
import dayjs from 'dayjs';

export const getAdminUserListingService = async (data) => {
  const { per_page, page, search, designation, territory, area, state } = data;

  const stateQueryParams = state?.map((id, index) => `&state[${index}]=${id}`)?.join('');
  const designationQueryParams = designation?.map((id, index) => `&designation[${index}]=${id}`)?.join('');
  const territoryQueryParams = territory?.map((id, index) => `&territory[${index}]=${id}`)?.join('');
  const areaQueryParams = area?.map((id, index) => `&area[${index}]=${id}`)?.join('');
  const searchParam = search ? `&search=${search}` : ``;

  return await axios.get(
    `${API_BASE_URL}/users?page=${page}&per_page=${per_page}${searchParam}${designationQueryParams}${stateQueryParams}${territoryQueryParams}${areaQueryParams}`
  );
};

export const rolesPermissionsService = async (data) => {
  const { per_page, page, search } = data;
  return await axios.get(`${API_BASE_URL}/roles?per_page=${per_page}&page=${page}&search=${search}`);
};
// export const getAdminUserListingService = async (data) => {
//   const { per_page, page, search, designation, territory, area } = data;
//   return await axios.get(
//     `${API_BASE_URL}/users?per_page=${per_page}&page=${page}&search=${search}&designation=[${designation}]&territory=${territory}&area=${area}`
//   );
// };
export const getAdminUserDetailsService = async (id) => {
  return await axios.get(`${API_BASE_URL}/users/${id}`);
};
export const deleteAdminUserService = async (id) => {
  return await axios.delete(`${API_BASE_URL}/users/${id}`);
};

export const deleteLeadService = async (id) => {
  return await axios.delete(`${API_BASE_URL}/lead/delete-lead/${id}`);
};

export const addNewUserService = async (data) => {
  return await axios.post(`${API_BASE_URL}/users`, data);
};

export const addNewLeadService = async (data) => {
  return await axios.post(`${API_BASE_URL}/lead`, data);
};

export const editLeadService = async (data) => {
  return await axios.post(`${API_BASE_URL}/lead/update-lead`, data);
};

export const AddLeadExchangeDetails = async (data) => {
  return await axios.post(`${API_BASE_URL}/lead/update-lead-exchange-details`, data);
};

export const AddExchangeDetails = async (data) => {
  return await axios.post(`${API_BASE_URL}/lead/evaluation-vehicle-details`, data);
};

// export const deleteDocuments = async (data) => {
//   return await axios.delete(`${API_BASE_URL}/lead/delete-document`, data);
// };
export const deleteDocuments = async (data) => {
  return await axios.delete(`${API_BASE_URL}/lead/delete-document`, {
    data: data,
  });
};

export const uploadCustomerDocumentsService = async (data) => {
  return await axios.post(`${API_BASE_URL}/lead/customer-document-uploads`, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const AddBooking = async (data) => {
  return await axios.post(`${API_BASE_URL}/lead/booking`, data);
};

export const updateAdminUserService = async (id, data) => {
  return await axios.put(`${API_BASE_URL}/users/${id}`, data);
};
export const updatePermissionsService = async (data) => {
  return await axios.put(`${API_BASE_URL}/roles/update-permission`, data);
};

export const getLeadsListingService = async (data) => {
  const {
    per_page,
    page,
    search,
    lead_status,
    lead_type,
    lead_stage,
    model_type,
    fuel_type,
    rto_locations,
    lead_sources,
    variant_type,
    state_id,
    territory_id,
    area_id,
    lead_owned,
    follow_up_date_id,
    graph_metrics,
    date_range,
    start_date,
    end_date,
    test_drive_completed,
    home_visit_completed,
    kpi_parameter,
    procured,
    vas_report_redirect,
    exchange_car,
    evaluation_completed,
    greater_than_one_day,
    greater_than_ten_day,
    greater_than_twenty_day,
    last_month,
    dashboard_redirect,
    live_lead,
    exclude_user_ids,
    target_redirect,
    month,
    year,
    booking_completed,
    lead_funnel_redirect,
    // New filter
    current_month,
    // New filters from menu
    lead_exchange_stage_id,
    exchange_officer_id,
    unevaluated_leads,
    approval_pending_for_final_inspection,
    allocation_status,
    file_stage_id,
    document_collection_pending,
    delivery_approval_pending,
    live_booking_redirect,
    live_booking_category,
    mtd_booking_redirect,
  } = data;
  const formattedStartDate = start_date && dayjs(start_date).format('YYYY-MM-DD');
  const formattedEndDate = end_date && dayjs(end_date).format('YYYY-MM-DD');
  const leadStatusQueryParams = lead_status?.map((id, index) => `&lead_status[${index}]=${id}`)?.join('');
  const leadTypeQueryParams = lead_type?.map((id, index) => `&lead_type[${index}]=${id}`)?.join('');
  const leadStageQueryParams = lead_stage?.map((id, index) => `&lead_stage[${index}]=${id}`)?.join('');
  const fuelTypeQueryParams = fuel_type?.map((id, index) => `&fuel_type[${index}]=${id}`)?.join('');
  const modalTypeQueryParams = model_type?.map((id, index) => `&model_type[${index}]=${id}`)?.join('');
  const rtoLocationsQueryParams = rto_locations?.map((id, index) => `&rto_locations[${index}]=${id}`)?.join('');
  const leadSourcesQueryParams = lead_sources?.map((id, index) => `&lead_sources[${index}]=${id}`)?.join('');
  const variantQueryParams = variant_type?.map((id, index) => `&variant_type[${index}]=${id}`)?.join('');
  let stateIds = Array.isArray(state_id) ? state_id : [state_id];
  const stateQueryParams = stateIds?.map((id, index) => `&state_id[${index}]=${id}`)?.join('');
  const territoryQueryParams = territory_id?.map((id, index) => `&territory_id[${index}]=${id}`)?.join('');
  const areaQueryParams = area_id?.map((id, index) => `&area_id[${index}]=${id}`)?.join('');
  const leadOwnedQueryParams = lead_owned?.map((id, index) => `&lead_owned[${index}]=${id}`)?.join('');

  const followUpDataByQueryParams = follow_up_date_id
    ?.map((id, index) => `&follow_up_date_id[${index}]=${id}`)
    ?.join('');
  const testDriveCompletedParam = test_drive_completed ? `&test_drive_completed=${test_drive_completed}` : '';
  const homeVisitCompletedParam = home_visit_completed ? `&home_visit_completed=${home_visit_completed}` : '';
  const kpiParameterQueryParam = kpi_parameter ? `&kpi_parameter=${kpi_parameter}` : '';
  const procuredQueryParam = procured ? `&procured=${procured}` : '';
  const vasReportRedirectQueryParam = vas_report_redirect ? `&vas_report_redirect=${vas_report_redirect}` : '';
  const exchangeCarParam = exchange_car ? `&exchange_car=${exchange_car}` : '';
  const evaluationCompletedParam = evaluation_completed ? `&evaluation_completed=${evaluation_completed}` : '';
  const graphMetrics = graph_metrics ? `&graph_metrics=${graph_metrics}` : '';
  const dateRangeParam = date_range ? `&date_range=${date_range}` : '';
  const startDateParam = formattedStartDate ? `&start_date=${formattedStartDate}` : '';
  const endDateParam = formattedEndDate ? `&end_date=${formattedEndDate}` : '';
  const greaterThanOneDayParam = greater_than_one_day ? `&greater_than_one_day=${greater_than_one_day}` : '';
  const greaterThanTwentyDayParam = greater_than_twenty_day
    ? `&greater_than_twenty_day=${greater_than_twenty_day}`
    : '';
  const greaterThanTenDayParam = greater_than_ten_day ? `&greater_than_ten_day=${greater_than_ten_day}` : '';
  const lastMonthParam = last_month ? `&last_month=${last_month}` : '';
  const dashboardRedirectParam =
    dashboard_redirect && !live_booking_redirect && !mtd_booking_redirect
      ? `&dashboard_redirect=${dashboard_redirect}`
      : "";
  const searchParam = search ? `&search=${search}` : '';
  const liveLeadParam = live_lead ? `&live_lead=${live_lead}` : '';
  const excludeIdQueryParams = exclude_user_ids?.map((id, index) => `&exclude_user_ids[${index}]=${id}`)?.join('');
  const targetRedirectQueryParams = target_redirect ? `&target_redirect=true` : '';
  const monthQueryParams = month ? `&month=${month}` : '';
  const yearQueryParams = year ? `&year=${year}` : '';
  const bookingCompletedParams = booking_completed ? `&booking_completed=1` : '';
  const leadFunnelRedirectParams = lead_funnel_redirect ? `&lead_funnel_redirect=true` : '';
  const currentMonthParam = current_month ? `&current_month=${current_month}` : '';
  // return await axios.get(
  //   `${API_BASE_URL}/lead?per_page=${per_page}&page=${page}${searchParam}${leadTypeQueryParams}${leadStatusQueryParams}${leadStageQueryParams}${modalTypeQueryParams}${fuelTypeQueryParams}${rtoLocationsQueryParams}${leadSourcesQueryParams}${variantQueryParams}${stateQueryParams}${territoryQueryParams}${areaQueryParams}${leadOwnedQueryParams}${followUpDataByQueryParams}${graphMetrics}${dateRangeParam}${startDateParam}${endDateParam}${testDriveCompletedParam}${homeVisitCompletedParam}${exchangeCarParam}${evaluationCompletedParam}${greaterThanOneDayParam}${greaterThanTenDayParam}${greaterThanTwentyDayParam}${lastMonthParam}${dashboardRedirectParam}${liveLeadParam}`
  // );

  const leadExchangeStageParam = lead_exchange_stage_id ? `&lead_exchange_stage_id=${lead_exchange_stage_id}` : '';
  const exchangeOfficerParam = exchange_officer_id ? `&exchange_officer_id=${exchange_officer_id}` : '';
  const unevaluatedParam = unevaluated_leads ? `&unevaluated_leads=${unevaluated_leads}` : '';
  const approvalPendingParam = approval_pending_for_final_inspection
    ? `&approval_pending_for_final_inspection=${approval_pending_for_final_inspection}`
    : '';
  const allocationStatusParam = allocation_status !== null && allocation_status !== undefined
    ? `&allocation_status=${allocation_status}`
    : '';
  const fileStageIdParam = file_stage_id !== null && file_stage_id !== undefined
    ? `&file_stage_id=${file_stage_id}`
    : '';
  const documentCollectionPendingParam = document_collection_pending ? `&document_collection_pending=${document_collection_pending}` : '';
  const deliveryApprovalPendingParam = delivery_approval_pending ? `&delivery_approval_pending=${delivery_approval_pending}` : '';
  const liveBookingRedirectParam = live_booking_redirect
    ? `&live_booking_redirect=${live_booking_redirect}`
    : "";
  const liveBookingCategoryParam = live_booking_category
    ? `&live_booking_category=${live_booking_category}`
    : "";
  const mtdBookingRedirectParam = mtd_booking_redirect
    ? `&mtd_booking_redirect=${mtd_booking_redirect}`
    : "";

  const queryParams = `${searchParam}${leadTypeQueryParams}${leadStatusQueryParams}${leadStageQueryParams}${modalTypeQueryParams}${fuelTypeQueryParams}${rtoLocationsQueryParams}${leadSourcesQueryParams}${variantQueryParams}${stateQueryParams}${territoryQueryParams}${areaQueryParams}${leadOwnedQueryParams}${followUpDataByQueryParams}${graphMetrics}${dateRangeParam}${startDateParam}${endDateParam}${testDriveCompletedParam}${homeVisitCompletedParam}${kpiParameterQueryParam}${procuredQueryParam}${vasReportRedirectQueryParam}${exchangeCarParam}${evaluationCompletedParam}${greaterThanOneDayParam}${greaterThanTenDayParam}${greaterThanTwentyDayParam}${lastMonthParam}${dashboardRedirectParam}${liveLeadParam}${leadExchangeStageParam}${exchangeOfficerParam}${unevaluatedParam}${approvalPendingParam}${allocationStatusParam}${fileStageIdParam}${documentCollectionPendingParam}${deliveryApprovalPendingParam}${liveBookingRedirectParam}${liveBookingCategoryParam}${mtdBookingRedirectParam}${excludeIdQueryParams ? excludeIdQueryParams : ''
    }${targetRedirectQueryParams}${monthQueryParams}${yearQueryParams}${bookingCompletedParams}${leadFunnelRedirectParams}${currentMonthParam}`;

  return await axios.get(`${API_BASE_URL}/lead?per_page=${per_page}&page=${page}${queryParams}`);
};
export const getExchangeLeadsList = async (data) => {
  const {
    per_page,
    page,
    search,
    model_type,
    start_date,
    end_date,
    lead_type = [],
    lead_stage = [],
    territory_id = [],
    area_id = [],
    lead_owned = [],
    ...filters
  } = data;

  const query = new URLSearchParams({
    per_page,
    page,
    search,
  });

  // Append lead_type and lead_stage as arrays
  lead_type.forEach((type, index) => query.append(`lead_type[${index}]`, type));
  lead_stage.forEach((stage, index) => query.append(`lead_stage[${index}]`, stage));
  territory_id.forEach((territory, index) => query.append(`territory_id[${index}]`, territory));
  area_id.forEach((area, index) => query.append(`area_id[${index}]`, area));
  lead_owned.forEach((owner, index) => query.append(`lead_owned[${index}]`, owner));

  // Append model_type, start_date, and end_date directly if they exist
  if (model_type.length) {
    model_type.forEach((type, index) => query.append(`model_type[${index}]`, type));
  }

  if (start_date) {
    query.append('start_date', start_date);
  }

  if (end_date) {
    query.append('end_date', end_date);
  }

  // Append other filters if not null/undefined (including 0 and false)
  Object.entries(filters)?.forEach(([key, value]) => {
    if (value !== null && value !== undefined) query.append(key, value);
  });

  return await axios.get(`${API_BASE_URL}/lead?${query.toString()}`);
};

// export const getExchangeLeadsList = async (data) => {
//   const {
//     per_page,
//     page,
//     search,
//     // model_type,
//     // start_date,
//     // end_date,
//     lead_type = [],
//     lead_stage = [],
//     ...filters
//   } = data;

//   const query = new URLSearchParams({
//     per_page,
//     page,
//     search,
//   });

//   // Append lead_type and lead_stage as arrays
//   lead_type.forEach((type, index) => query.append(`lead_type[${index}]`, type));
//   lead_stage.forEach((stage, index) =>
//     query.append(`lead_stage[${index}]`, stage)
//   );

//   // Append only the truthy filters
//   Object.entries(filters)?.forEach(([key, value]) => {
//     if (value) query.append(key, true);
//   });

//   return await axios.get(`${API_BASE_URL}/lead?${query.toString()}`);
// };

export const getLeadDetailsService = async (id) => {
  return await axios.get(`${API_BASE_URL}/lead/${id}`);
};

// Get Exchange Evaluation PDF URL for a lead
export const getExchangeEvaluationPdfUrl = async (leadId) => {
  return await axios.get(
    `${API_BASE_URL}/lead/exchange/exchange-evaluation-pdf-url/${leadId}`
  );
};

export const getEchangeVehicleDetails = async (id) => {
  return await axios.get(`${API_BASE_URL}/master/exchange-vehicle-details/${id}`);
};

export const getExistingCustomerService = async (phone_no) => {
  return await axios.get(`${API_BASE_URL}/lead/check-existing-customer?phone_no=${phone_no}`);
};
// Lead Finance Information - List
export const getLeadFinanceInformationService = async (params) => {
  return await axios.get(`${API_BASE_URL}/lead/finance-information`, { params });
};

// Lead Finance Information - Delete
export const deleteLeadFinanceInformationService = async (id) => {
  return await axios.delete(`${API_BASE_URL}/lead/finance-information/${id}`);
};

// Lead Finance Information - Create
export const addLeadFinanceInformationService = async (formData) => {
  return await axios.post(`${API_BASE_URL}/lead/finance-information`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

// Lead Finance Information - Get by ID
export const getLeadFinanceInformationByIdService = async (id) => {
  return await axios.get(`${API_BASE_URL}/lead/finance-information/${id}`);
};

// Lead Finance Information - Update
export const updateLeadFinanceInformationService = async (formData) => {
  return await axios.post(`${API_BASE_URL}/lead/finance-information/update-finance-information`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

// Payments - Transactions
export const getPaymentTransactionsService = async (params) => {
  return await axios.get(`${API_BASE_URL}/lead/payment-transaction`, { params });
};

export const addPaymentTransactionService = async (formData) => {
  return await axios.post(`${API_BASE_URL}/lead/payment-transaction`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const updatePaymentTransactionService = async (formData) => {
  return await axios.post(`${API_BASE_URL}/lead/payment-transaction/update-transaction-details`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const getPaymentTransactionByIdService = async (id) => {
  return await axios.get(`${API_BASE_URL}/lead/payment-transaction/${id}`);
};

export const deletePaymentTransactionService = async (id, remarks) => {
  return await axios.delete(`${API_BASE_URL}/lead/payment-transaction/${id}`, {
    data: { remarks },
  });
};

export const getLeadRequestsService = async (params) => {
  return await axios.get(`${API_BASE_URL}/lead/request`, { params });
};

export const downloadGatePassService = async (leadId) => {
  return await axios.get(`${API_BASE_URL}/lead/request/download-gate-pass/${leadId}`);
};
export const viewGatePassService = async (leadId) => {
  return await axios.get(`${API_BASE_URL}/lead/request/view-gate-pass/${leadId}`);
};

export const createLeadRequestService = async (data) => {
  return await axios.post(`${API_BASE_URL}/lead/request/create-request`, data);
};

export const approveRejectLeadRequestService = async (data) => {
  return await axios.put(`${API_BASE_URL}/lead/request/approve-reject-request`, data);
};

export const getAllocationRequestsListService = async (params) => {
  return await axios.get(`${API_BASE_URL}/lead/request/allocation-requests-list`, { params });
};

export const getDeliveryRequestsListService = async (params) => {
  return await axios.get(`${API_BASE_URL}/lead/request/delivery-requests-list`, { params });
};

export const getCancellationRequestsListService = async (params) => {
  return await axios.get(`${API_BASE_URL}/lead/request/cancellation-requests-list`, { params });
};

export const getPendingRequestsListService = async (params) => {
  return await axios.get(`${API_BASE_URL}/lead/request/pending-requests-list`, { params });
};
